/**
 * @module app.hideDirective
 */
import appBase from './index.js';

/**
 * @return {angular.Directive} The directive specs.
 * @ngInject
 */
const directive = function() {
  return {
    restrict: 'A',
    link:
        /**
         * @param {angular.Scope} $scope Scope.
         * @param {jQuery} element Element.
         * @param {angular.Attributes} attrs Attributes.
         */
        function($scope, element, attrs) {
          $scope.$watch(attrs['appHide'], function(hide) {
            const inputs = element.find("input:not([app-checkbox])");
            if (hide) {
              // uncheck all individual layers, skip the checkbox for the group
              inputs.filter(':checked').click();
              // hide and disable all the inputs
              inputs.prop('disabled', true);
              element.addClass('ng-hide');
            } else {
              element.removeClass('ng-hide');
              inputs.prop('disabled', false);
            }
            // trigger a change event so that the parent checkbox status
            // (on, off or indeterminate) is re-computed.
            inputs.trigger('change');
          });
        }
  };
};

export default appBase.directive('appHide', directive);
